export * from "./src/currency-mask.directive";
export * from "./src/currency-mask.module";
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/micro/Downloads/Proyectos/PagosContabilidadUriel/~/ngx-currency/index.js
// module id = ../../../../ngx-currency/index.js
// module chunks = 3